import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 19,
	viewBox: "0 0 17 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "arrow-left",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.4587 9.2782H3.54199",
			stroke: "#2C2C27",
			strokeWidth: 1.0625,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M8.50033 14.6905L3.54199 9.2782L8.50033 3.86594",
			stroke: "#2C2C27",
			strokeWidth: 1.0625,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgArrowLeft;
